import * as React from "react";
import { ProductCard } from "../../NormalProducts/ProductCard";
import { DoubleContainer, GridRowTwoBox } from "./styles";
import { SwipeProductProps } from "../GridOne";
import { TProductElement } from "../../../../services/product";
import { LeftIconArrow, RightsIconArrow } from "../GridOne/styles";

const _animationDuration = 1000;

export interface DoubleSwipeProps extends SwipeProductProps {
	cardWidth: string | number;
	posterHeight: number;
}

interface DoubleSwipeState {
	cIndex: number;
	animationDuration: number;
	aniIndex: number;
}

class DoubleSwipe extends React.Component<DoubleSwipeProps, DoubleSwipeState> {
	canClick: boolean = true;
	autoSwipe: boolean = true;
	countDown: any = 0;
	private gridCellLen: number = this.props.gridCol * 2;

	state: DoubleSwipeState = {
		cIndex: 0,
		animationDuration: 0,
		aniIndex: 1,
	};
	onBack = () => {
		const { cIndex } = this.state;
		const { products } = this.props;
		if (!this.canClick) {
			return;
		}
		this.canClick = false;
		this.setState({
			aniIndex: 0,
			animationDuration: _animationDuration,
		});
		setTimeout(() => {
			const newCIndex = cIndex - this.gridCellLen;
			this.setState({
				cIndex: newCIndex < 0 ? products.length + newCIndex : newCIndex,
				animationDuration: 0,
				aniIndex: 1,
			});
			this.canClick = true;
		}, _animationDuration);

		this.props.onClickBack && this.props.onClickBack();
	};

	onNext = () => {
		const { cIndex } = this.state;
		const { products } = this.props;
		if (!this.canClick || products.length <= this.gridCellLen) {
			return;
		}
		this.canClick = false;

		this.setState({
			aniIndex: 2,
			animationDuration: _animationDuration,
		});
		setTimeout(() => {
			const newCIndex = cIndex + this.gridCellLen;
			this.setState({
				cIndex: newCIndex >= products.length ? newCIndex - products.length : newCIndex,
				animationDuration: 0,
				aniIndex: 1,
			});
			this.canClick = true;
		}, _animationDuration);

		this.props.onClickNext && this.props.onClickNext();
	};

	getDoubleStyle = () => {
		const { aniIndex, animationDuration } = this.state;
		const style: React.CSSProperties = {};
		const { gridWidth = 1200 } = this.props;

		style.width = "300%";

		const wrapperOffsetLeft = -gridWidth * aniIndex;
		style.transform = `translate3d(${wrapperOffsetLeft}px,0,0)`;
		style.transitionDuration = `${animationDuration}ms`;
		style.WebkitTransform = style.transform;
		style.transitionTimingFunction = "ease-out";
		return style;
	};

	renderCard = (product: TProductElement, index: number) => {
		const {
			cardWidth,
			posterRatio,
			layoutStyle,
			placeholderBg,
			onClick,
			scoreOptions,
			poolId,
		} = this.props;

		return (
			<ProductCard
				key={index}
				product={product}
				width={`${cardWidth}px`}
				posterRatio={posterRatio}
				gridCol={this.props.gridCol}
				layoutStyle={layoutStyle}
				onClick={() => onClick && onClick((index + 1).toString(), product.gpid)}
				placeholderBg={placeholderBg}
				collectOptions={scoreOptions}
				poolId={poolId}
			/>
		);
	};

	renderLeft = () => {
		const { products } = this.props;
		const { cIndex } = this.state;
		if (!cIndex) {
			return products
				.slice(-this.gridCellLen)
				.map((product, index) => this.renderCard(product, index));
		}
		if (cIndex - this.gridCellLen < 0) {
			return products
				.slice(-(this.gridCellLen - cIndex))
				.concat(products.slice(0, cIndex))
				.map((product, index) => this.renderCard(product, index));
		}
		return products
			.slice(cIndex - this.gridCellLen, cIndex)
			.map((product, index) => this.renderCard(product, index));
	};

	renderMiddle = () => {
		const { products } = this.props;
		const { cIndex } = this.state;
		if (cIndex + this.gridCellLen > products.length) {
			return products
				.slice(cIndex)
				.concat(products.slice(0, cIndex + this.gridCellLen - products.length))
				.map((product, index) => this.renderCard(product, index));
		}
		return products
			.slice(cIndex, cIndex + this.gridCellLen)
			.map((product, index) => this.renderCard(product, index));
	};

	renderRight = () => {
		const { products } = this.props;
		const { cIndex } = this.state;
		// →1 没有超 →this.gridCellLen 没有超
		const nextCIndex = cIndex + this.gridCellLen * 2;
		if (nextCIndex <= products.length) {
			return products
				.slice(cIndex + this.gridCellLen, cIndex + this.gridCellLen * 2)
				.map((product, index) => this.renderCard(product, index));
			// →1 没有超 →this.gridCellLen 超了
		}
		if (nextCIndex > products.length && cIndex + this.gridCellLen < products.length) {
			return products
				.slice(cIndex + this.gridCellLen)
				.concat(
					products.slice(
						0,
						this.gridCellLen - (products.length - (cIndex + this.gridCellLen)),
					),
				)
				.map((product, index) => this.renderCard(product, index));
			// →1 超了 →this.gridCellLen 超了两轮
		}
		if (cIndex + this.gridCellLen > products.length && nextCIndex > products.length * 2) {
			return products
				.slice(this.gridCellLen - (products.length - cIndex))
				.concat(
					products.slice(
						0,
						this.gridCellLen -
							products.slice(this.gridCellLen - (products.length - cIndex)).length,
					),
				)
				.map((product, index) => this.renderCard(product, index));
			// →1 超了 →this.gridCellLen 超了
		}
		return products
			.slice(
				this.gridCellLen - (products.length - cIndex),
				this.gridCellLen * 2 - (products.length - cIndex),
			)
			.map((product, index) => this.renderCard(product, index));
	};

	render() {
		const { posterHeight, gridCol, gridGap, cardWidth, gridWidth, handWheel } = this.props;
		return (
			<DoubleContainer
				onMouseEnter={() => (this.autoSwipe = false)}
				onMouseLeave={() => (this.autoSwipe = true)}
			>
				<LeftIconArrow
					height={handWheel?.height}
					width={handWheel?.width}
					onClick={this.onBack}
				/>

				<section className={"scrollContainer"} style={this.getDoubleStyle()}>
					<div className={"box"}>
						<GridRowTwoBox
							posterHeight={posterHeight}
							gridCol={gridCol}
							cardWidth={cardWidth}
							gridGap={gridGap}
							gridWidth={gridWidth}
						>
							{this.renderLeft()}
						</GridRowTwoBox>
					</div>
					<div className={"box"}>
						<GridRowTwoBox
							posterHeight={posterHeight}
							gridCol={gridCol}
							cardWidth={cardWidth}
							gridGap={gridGap}
							gridWidth={gridWidth}
						>
							{this.renderMiddle()}
						</GridRowTwoBox>
					</div>
					<div className={"box"}>
						<GridRowTwoBox
							posterHeight={posterHeight}
							gridCol={gridCol}
							cardWidth={cardWidth}
							gridGap={gridGap}
							gridWidth={gridWidth}
						>
							{this.renderRight()}
						</GridRowTwoBox>
					</div>
				</section>
				<RightsIconArrow {...handWheel} onClick={this.onNext} />
			</DoubleContainer>
		);
	}
}

export default DoubleSwipe;
